export interface IFieldMetaData {
  editable?: boolean;
  copyable?: boolean;
  tooltip?: string;
  isSuperColumn?: boolean;
  superColumnId?: number;
  labelName?: string; // Display name for UI
  subColumns?: IFieldMetaData[]; // Sub Columns of the field
}
